import React, { useEffect, useState } from 'react'
import { Wrapper } from './ContentTabHome.styles'
import GradientBackground from 'components/gradient-background'
import { tokens } from '@arvoreeducacao/bonsai-ds'
import type { ContentTabHomeProps } from './ContentTabHome.types'

const ContentTabHome: React.FC<ContentTabHomeProps> = ({
  children,
  id,
  fadeOut,
  backgroundColor
}) => {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setReady(true), 50)
    return () => clearTimeout(timer)
  }, [])

  const backgroundGradientColor = backgroundColor
    ? `linear-gradient(to bottom,${backgroundColor},${tokens.colors.white} 300px)`
    : undefined

  return (
    <Wrapper id={id} isVisible={ready && !fadeOut}>
      {backgroundGradientColor && (
        <GradientBackground color={backgroundGradientColor} />
      )}
      {children}
    </Wrapper>
  )
}

export default ContentTabHome
